import styled from 'styled-components';
import { tvar } from '@versita/frontend/design-tokens';
import { CardProps } from './Card';

export const StyledCard = styled.div<CardProps>`
  padding: ${tvar('space.x4')} ${tvar('space.x2')};
  background: ${tvar('colors.neutrals.grey2')};
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'min-content')};
  @media (min-width: ${tvar('measures.breakpoints.tabletSm')}) {
    padding: ${tvar('space.x4')};
  }

  &:not(:last-child) {
    margin-bottom: ${tvar('space.x5')};
  }
`;
